import React, { useState, useEffect } from 'react';
import printJS from 'print-js';
import moment from 'moment';
import AlertMessage from '../../AlertMessage';
import { FiPrinter, FiSearch } from 'react-icons/fi';

const Form15A = () => {
  const [schoolData, setSchoolData] = useState(null);
  const [loading, setLoading] = useState(true);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const language = localStorage.getItem('language') || 'English';
  const userStatus = localStorage.getItem("userStatus");
  const isEditable = userStatus === "DKglzhgYFYTDT141414HGCkkgfs22117785YFUTFybnujghhgtghghYFYVNOmC234567Omgkysfgvghyfjhyfvv56764" || localStorage.getItem("editable") === "true";

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [duplicateStudents, setDuplicateStudents] = useState([]);
  const [showDuplicatePopup, setShowDuplicatePopup] = useState(false);

  const [formData, setFormData] = useState({
    refNo: '',
    studentName: '',
    academicYear: '2025-2026',
    std: '',
    faculty: '',
    grNumber: '',
    caste: '',
    place: 'Sambhajinagar, Baramati',
    date: moment().format('YYYY-MM-DD'),
    serialNo: '',
    owtId: '',
    showOwtId: false
  });

  useEffect(() => {
    if (alertMessage) {
      setShowAlert(true);
      const timer = setTimeout(() => {
        setShowAlert(false);
        setAlertMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [alertMessage]);

  useEffect(() => {
    if (udiseNumber) {
      fetchSchoolData(udiseNumber);
    }
  }, [udiseNumber]);

  useEffect(() => {
    const fetchOutwardIds = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/outwardIds.json`);
        if (!response.ok) {
          throw new Error('Failed to fetch outward IDs');
        }
        const data = await response.json();

        if (data) {
          setFormData(prevData => ({
            ...prevData,
            owtId: data.current + 1
          }));
        }

      } catch (error) {
        console.error('Error fetching outward IDs:', error);
      }
    };
    if (udiseNumber) {
      fetchOutwardIds();
    }
  }, [udiseNumber]);

  const fetchSchoolData = async (udise) => {
    try {
      const request = indexedDB.open('SchoolManagementDB', 1);
      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['schoolData'], 'readonly');
        const objectStore = transaction.objectStore('schoolData');
        const getReq = objectStore.get(udise);

        getReq.onsuccess = (e) => {
          const data = e.target.result;
          if (data) {
            setSchoolData(data);
            
            // Construct the place automatically from school address and taluka
            const address = data.address || '';
            const taluka = data.taluka || '';
            const cleanAddr = address.trim().replace(/[,.]+$/, '');
            const words = cleanAddr.split(/[\s,]+/);
            const lastWord = words.length > 0 ? words[words.length - 1] : '';
            
            let defaultPlace = 'Sambhajinagar, Baramati';
            if (lastWord && taluka) {
              if (lastWord.toLowerCase() !== taluka.toLowerCase()) {
                defaultPlace = `${lastWord}, ${taluka}`;
              } else {
                defaultPlace = taluka;
              }
            } else if (lastWord) {
              defaultPlace = lastWord;
            } else if (taluka) {
              defaultPlace = taluka;
            }

            setFormData(prev => ({
              ...prev,
              place: defaultPlace
            }));
          }
          setLoading(false);
        };
        getReq.onerror = () => setLoading(false);
      };
      request.onerror = () => setLoading(false);
    } catch (err) {
      console.error("Error reading indexedDB:", err);
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === 'grNumber') {
      if (!value.trim()) return;
      try {
        const request = indexedDB.open('SchoolManagementDB', 1);
        request.onsuccess = (event) => {
          const db = event.target.result;
          const transaction = db.transaction(['studentData'], 'readonly');
          const objectStore = transaction.objectStore('studentData');
          const studentRequest = objectStore.getAll();

          studentRequest.onsuccess = (ev) => {
            const students = ev.target.result;
            if (students && Array.isArray(students)) {
              const query = value.toLowerCase();
              const match = students.find(s => s.registerNo && s.registerNo.toString() === query);
              if (match) {
                autoFillStudent(match);
              }
            }
          };
        };
      } catch (error) {
        console.error("IndexedDB error:", error);
      }
    }
  };

  const handleSearchInputChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);

    if (!value.trim()) {
      clearStudentFields();
      return;
    }

    try {
      const request = indexedDB.open('SchoolManagementDB', 1);
      request.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction(['studentData'], 'readonly');
        const objectStore = transaction.objectStore('studentData');
        const studentRequest = objectStore.getAll();

        studentRequest.onsuccess = (ev) => {
          const students = ev.target.result;
          if (students && Array.isArray(students)) {
            const query = value.toLowerCase();
            const matches = students.filter(s =>
              (s.registerNo && s.registerNo.toString() === query) ||
              (`${s.stdName || ''} ${s.stdFather || ''} ${s.stdSurname || ''}`.toLowerCase().includes(query))
            );

            if (matches.length >= 1) {
              const selectedStudent = matches.find(s => s.isActive !== false) || matches[0];
              autoFillStudent(selectedStudent);
            }
          }
        };
      };
    } catch (error) {
      console.error("IndexedDB error:", error);
    }
  };

  const autoFillStudent = (student) => {
    const getSchoolInitials = (name) => {
      if (!name) return 'LSF';
      const cleanName = name.replace(/[^\w\s]/gi, ''); // remove special characters
      return cleanName
        .split(/\s+/)
        .filter(word => !['of', 'and', 'the', 'a', 'an', 'in', 'to', 'for'].includes(word.toLowerCase()))
        .map(word => word.charAt(0).toUpperCase())
        .join('');
    };

    const schoolInitials = getSchoolInitials(schoolData?.schoolName);
    const currentYear = formData.date ? moment(formData.date).format('YYYY') : moment().format('YYYY');
    const autoRefNo = `${schoolInitials}/${currentYear}/${student.registerNo || ''}`;

    const keyParts = student.id ? student.id.split('-') : [];
    const idSerialNo = keyParts.length > 0 ? keyParts[keyParts.length - 1] : '';
    const finalSerialNo = student.serialNo || idSerialNo || '';

    setFormData(prev => ({
      ...prev,
      refNo: autoRefNo,
      studentName: `${student.stdName || ''} ${student.stdFather || ''} ${student.stdSurname || ''}`.trim(),
      grNumber: student.registerNo || '',
      caste: Array.from(new Set([student.religion, student.caste, student.subCaste, student.category].filter(Boolean))).join(' - '),
      std: student.currentClass || '',
      faculty: student.branch || '',
      serialNo: finalSerialNo
    }));
    setSearchInput(student.registerNo || `${student.stdName || ''} ${student.stdSurname || ''}`.trim());
    setShowDuplicatePopup(false);
  };

  const clearStudentFields = () => {
    setFormData(prev => ({
      ...prev,
      refNo: '',
      studentName: '',
      grNumber: '',
      caste: '',
      std: '',
      faculty: '',
      owtId: ''
    }));
  };

  const printDocument = async () => {
    const printContent = document.getElementById("form-15a-print-content");
    if (!printContent) return;

    // Register Outward ID in Firebase
    if (udiseNumber) {
      try {
        const outwardIdBaseUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/outwardIds`;
        const outwardIdResponse = await fetch(outwardIdBaseUrl + '.json');
        const outwardIdData = await outwardIdResponse.json() || {};

        const currentOutwardId = outwardIdData.current || 0;
        const nextOutwardId = currentOutwardId + 1;

        const outwardIdEntry = {
          serialNo: formData.serialNo || formData.grNumber || '',
          reason: 'Form 15A Print',
          documentNumber: formData.refNo || `FORM15A/${nextOutwardId}`,
          date: moment(formData.date).format('DD-MM-YYYY'),
        };

        // Write new entry
        await fetch(outwardIdBaseUrl + `/${nextOutwardId}.json`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(outwardIdEntry),
        });

        // Update current
        await fetch(outwardIdBaseUrl + '/current.json', {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(nextOutwardId),
        });

        // Update local state temporarily for next fetch
        setFormData(prev => ({
          ...prev,
          owtId: nextOutwardId + 1
        }));

      } catch (err) {
        console.error("Error logging outward ID:", err);
      }
    }

    printJS({
      printable: printContent.innerHTML,
      type: 'raw-html',
      style: `
        @media print {
          @page {
            size: A4 Portrait;
            margin: 15mm 15mm 15mm 15mm;
          }
          body {
            font-family: 'Times New Roman', serif;
            color: #000;
            margin: 0;
            padding: 0;
          }
          .print-container {
            border: 1px solid #000;
            padding: 15mm;
            min-height: 260mm;
          }
          .header {
            text-align: center;
            border-bottom: 1px solid #000;
            padding-bottom: 10px;
            margin-bottom: 20px;
            position: relative;
          }
          .header img {
            width: 80px;
            position: absolute;
            left: 0;
            top: 0;
          }
          .sanstha-name {
            font-size: 14pt;
            margin: 0;
          }
          .school-name {
            font-size: 22pt;
            font-weight: bold;
            margin: 5px 0;
          }
          .address {
            font-size: 10pt;
            margin: 0;
          }
          .form-title {
            text-align: center;
            font-size: 14pt;
            margin: 20px 0;
          }
          .cert-title {
            text-align: center;
            font-weight: bold;
            font-size: 13pt;
            margin-bottom: 30px;
          }
          .main-text {
            font-size: 13pt;
            line-height: 2;
            text-align: justify;
          }
          .underline {
            display: inline-block;
            border-bottom: 1px dotted #000;
            padding: 0 10px;
            font-weight: bold;
          }
          .footer-section {
            margin-top: 50px;
            display: flex;
            justify-content: space-between;
          }
          .signature-area {
            text-align: center;
            width: 250px;
          }
          .seal-area {
            width: 100px;
            height: 100px;
            border: 1px dashed #ccc;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 8pt;
          }
          .instructions {
            margin-top: 50px;
            font-size: 10pt;
            line-height: 1.4;
          }
          .instructions h4 {
            text-decoration: underline;
            margin-bottom: 10px;
          }
        }
      `
    });
  };

  return (
    <div className="main-content-of-page" style={{ background: '#f3f5f9', minHeight: 'calc(100vh - 100px)', padding: '20px' }}>
      <AlertMessage message={alertMessage} show={showAlert} />

      <div style={{ display: 'flex', gap: '25px', flexWrap: 'wrap', maxWidth: '1400px', margin: '0 auto' }}>
        {/* Form Panel */}
        <div style={{ flex: '1 1 450px', background: '#ffffff', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)', padding: '25px' }}>
          <h3 style={{ color: '#03365e', marginBottom: '20px', fontWeight: 600 }}>Form 15A Generator</h3>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Auto-Fetch Student</label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                value={searchInput}
                onChange={handleSearchInputChange}
                placeholder="Search by name or Register No..."
                readOnly={!isEditable && formData.grNumber ? true : false}
                style={inputStyle}
              />
              <FiSearch style={{ position: 'absolute', right: '12px', top: '13px', color: '#999' }} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>O.W. No.</label>
              <input
                type="text"
                name="owtId"
                value={formData.owtId}
                onChange={handleInputChange}
                style={inputStyle}
                placeholder="Temporary O.W. No change"
              />
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px', gap: '8px', width: '100%' }}>
                <input
                  type="checkbox"
                  name="showOwtId"
                  checked={formData.showOwtId === true}
                  onChange={(e) => setFormData(prev => ({ ...prev, showOwtId: e.target.checked }))}
                  style={{ margin: 0, width: '18px', height: '18px', cursor: 'pointer', flex: 'none' }}
                />
                <label style={{ fontSize: '14px', cursor: 'pointer', margin: 0, padding: 0, flex: 'none', width: 'auto', fontWeight: '500', color: '#444' }}>
                  Show on Print
                </label>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Ref No.</label>
              <input
                type="text"
                name="refNo"
                value={formData.refNo}
                onChange={handleInputChange}
                style={inputStyle}
                placeholder="e.g. LSF/2026/102"
              />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Student Name</label>
              <input type="text" name="studentName" value={formData.studentName} onChange={handleInputChange} style={inputStyle} readOnly={!isEditable} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Academic Year</label>
              <select name="academicYear" value={formData.academicYear} onChange={handleInputChange} style={inputStyle}>
                <option value="2023-2024">2023-2024</option>
                <option value="2024-2025">2024-2025</option>
                <option value="2025-2026">2025-2026</option>
                <option value="2026-2027">2026-2027</option>
                <option value="2027-2028">2027-2028</option>
              </select>
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Std</label>
              <input type="text" name="std" value={formData.std} onChange={handleInputChange} style={inputStyle} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: '15px', marginBottom: '15px' }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Faculty</label>
              <input type="text" name="faculty" value={formData.faculty} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>GR Number</label>
              <input type="text" name="grNumber" value={formData.grNumber} onChange={handleInputChange} style={inputStyle} />
            </div>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label style={labelStyle}>Caste</label>
            <input type="text" name="caste" value={formData.caste} onChange={handleInputChange} style={inputStyle} readOnly={!isEditable} />
          </div>

          <div style={{ display: 'flex', gap: '15px', marginBottom: '20px' }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Place</label>
              <input type="text" name="place" value={formData.place} onChange={handleInputChange} style={inputStyle} />
            </div>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Date</label>
              <input type="date" name="date" value={formData.date} onChange={handleInputChange} style={inputStyle} />
            </div>
          </div>

          <button onClick={printDocument} style={printButtonStyle}>
            <FiPrinter size={20} /> Print Form 15A
          </button>
        </div>

        {/* Preview Panel */}
        <div style={{ flex: '2 1 600px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span style={{ background: '#03365e', color: '#fff', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', marginBottom: '10px' }}>
            LIVE PREVIEW
          </span>

          <div id="form-15a-print-content" style={previewContainerStyle}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              borderBottom: '2px solid #000',
              paddingBottom: '12px',
              marginBottom: '20px'
            }}>
              <div style={{ width: '100px', display: 'flex', justifyContent: 'flex-start' }}>
                {schoolData?.schoolLogo && (
                  <img src={schoolData.schoolLogo} alt="Logo" style={{ width: '90px', height: '90px', objectFit: 'contain' }} />
                )}
              </div>
              <div style={{ textAlign: 'center', flex: 1, padding: '0 15px' }}>
                <h2 style={{ fontSize: '12pt', fontWeight: 'bold', textTransform: 'uppercase', margin: '0 0 4px 0', lineHeight: '1.2' }}>
                  {schoolData?.sansthaName || "Ladkat Educational Foundation's"}
                </h2>
                <h1 style={{ fontSize: '18pt', fontWeight: 'bold', textTransform: 'uppercase', margin: '0 0 4px 0', color: '#000', lineHeight: '1.2' }}>
                  {schoolData?.schoolName || "Ladkat School of Foundation"}
                </h1>
                <p style={{ fontSize: '9pt', margin: '0 0 2px 0' }}>
                  {language === 'English' ? (
                    <>
                      {schoolData?.address && (
                        <>
                          <strong>At Post : </strong>{schoolData.address},{" "}
                        </>
                      )}
                      <strong>Taluka : </strong>{schoolData?.taluka},<strong> District : </strong>{schoolData?.jilha}
                    </>
                  ) : (
                    <>
                      {schoolData?.address && (
                        <>
                          <strong>मु. पो. : </strong>{schoolData.address},{" "}
                        </>
                      )}
                      <strong> तालुका : </strong>{schoolData?.taluka}, <strong>जिल्हा : </strong>{schoolData?.jilha}
                    </>
                  )}
                </p>
                <div style={{ display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '4px' }}>
                  <p style={{ fontSize: '9pt', margin: 0 }}>
                    <strong>{language === 'English' ? 'UDISE No :' : 'UDISE क्र :'}</strong> {schoolData?.udiseNumber}
                  </p>
                  {schoolData?.mobileNumber && (
                    <p style={{ fontSize: '9pt', margin: 0 }}>
                      <strong>Mob. No. :</strong> {schoolData.mobileNumber}
                    </p>
                  )}
                </div>
              </div>
              <div style={{ width: '100px' }}></div>
            </div>

            {/* Top References Row */}
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px', fontSize: '12pt' }}>
              <div>
                {formData.showOwtId === true && (
                  <>
                    <strong>O.W. No.:</strong> {formData.owtId || 'Not Generated'}&nbsp;&nbsp;&nbsp;&nbsp;
                  </>
                )}
                <strong>Ref. No.:</strong> {formData.refNo || '________________'}
              </div>
              <div>
                <strong>Date:</strong> {formData.date ? moment(formData.date).format('DD/MM/YYYY') : ''}
              </div>
            </div>

            <div style={{ textAlign: 'center', margin: '20px 0', fontSize: '16pt', fontWeight: 'bold' }}>Form - 15A</div>

            <div style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: '30px', fontSize: '14pt' }}>
              Certificate to be given by Principal of the School/College
            </div>

            <div style={{ fontSize: '14pt', lineHeight: '2', textAlign: 'justify' }}>
              This is to Certify that Kumar/Kumari <span style={formData.studentName ? { ...dottedUnderline, borderBottom: 'none' } : dottedUnderline}>{formData.studentName || '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}</span>
              is Student of this School /College in Year <span style={formData.academicYear ? { ...dottedUnderline, borderBottom: 'none' } : dottedUnderline}>{formData.academicYear || '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}</span> and he/she is studying in Std <span style={formData.std ? { ...dottedUnderline, borderBottom: 'none' } : dottedUnderline}>{formData.std || '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}</span>
              <span style={formData.faculty ? { ...dottedUnderline, borderBottom: 'none' } : dottedUnderline}>{formData.faculty || '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}</span> faculty. His/her name and other information is as per mentioned at number <span style={formData.grNumber ? { ...dottedUnderline, borderBottom: 'none' } : dottedUnderline}>{formData.grNumber || '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}</span>
              in general register. And the Caste stated as per our general register is <span style={formData.caste ? { ...dottedUnderline, borderBottom: 'none' } : dottedUnderline}>{formData.caste || '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0'}</span>
              (Strike out of if not applicable).
            </div>

            <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'space-between' }}>
              <div style={{ fontSize: '14pt' }}>
                <strong>Place :</strong> {formData.place}<br />
                <strong>Date :</strong> {formData.date ? moment(formData.date).format('DD/MM/YYYY') : ''}
              </div>
              <div style={{ textAlign: 'center', width: '250px' }}>
                <div style={{ height: '60px' }}></div>
                <div style={{ fontWeight: 'bold', fontSize: '14pt' }}>
                  Seal and Signature of the Principal/Head
                </div>
              </div>
            </div>

            <div style={{ marginTop: '60px', fontSize: '11.5pt', lineHeight: '1.4' }}>
              <h4 style={{ fontWeight: 'bold', textDecoration: 'underline', margin: '0 0 10px 0' }}>Important Instructions :</h4>
              <p style={{ margin: '0 0 6px 0' }}>a) If Claim for Scheduled Caste, Caste evidences should be prior to 10th August 1950.</p>
              <p style={{ margin: '0 0 6px 0' }}>b) If Claim for De-Notified Tribes (Vimukta Jatis), Nomadic Tribes Caste evidences should be prior to 21st November 1961.</p>
              <p style={{ margin: '0 0 6px 0' }}>c) If Claim for Other Backward Class and Special Backward Category, Caste evidences should be prior to 13th October 1967.</p>
              <p style={{ margin: '0 0 6px 0' }}>d) In addition, evidence of residents of the above mentioned prior is essential for applicant who has migrated in Maharashtra from other States.</p>
              <p style={{ margin: '0 0 6px 0' }}>e) Migrants from other States to Maharashtra after the above mentioned period whose Caste Certificate is in "Migrants" format should not apply to committee....</p>
            </div>
          </div>
        </div>
      </div>

      {showDuplicatePopup && (
        <div className="overlay" style={overlayStyle}>
          <div style={modalStyle}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
              <h4>Select Matching Student</h4>
              <button onClick={() => setShowDuplicatePopup(false)} style={{ border: 'none', background: 'none', fontSize: '20px', cursor: 'pointer' }}>&times;</button>
            </div>
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#f8f9fa' }}>
                    <th style={tableHeaderStyle}>Full Name</th>
                    <th style={tableHeaderStyle}>Class</th>
                    <th style={tableHeaderStyle}>Reg No</th>
                  </tr>
                </thead>
                <tbody>
                  {duplicateStudents.map((st, idx) => (
                    <tr key={idx} onClick={() => autoFillStudent(st)} style={{ borderBottom: '1px solid #eee', cursor: 'pointer' }}>
                      <td style={tableCellStyle}>{`${st.stdName || ''} ${st.stdFather || ''} ${st.stdSurname || ''}`}</td>
                      <td style={tableCellStyle}>{st.currentClass || '-'}</td>
                      <td style={tableCellStyle}>{st.registerNo || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '10px',
  borderRadius: '6px',
  border: '1px solid #ced4da',
  fontSize: '14px',
  boxSizing: 'border-box'
};

const labelStyle = {
  display: 'block',
  marginBottom: '5px',
  fontSize: '13px',
  fontWeight: '600',
  color: '#555'
};

const printButtonStyle = {
  background: '#28a745',
  color: '#fff',
  border: 'none',
  borderRadius: '8px',
  padding: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '10px',
  fontWeight: 'bold',
  cursor: 'pointer',
  width: '100%',
  marginTop: '10px'
};

const previewContainerStyle = {
  background: '#fff',
  width: '210mm',
  minHeight: '297mm',
  boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
  padding: '20mm',
  boxSizing: 'border-box',
  fontFamily: "'Times New Roman', serif"
};

const headerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderBottom: '2px solid #000',
  paddingBottom: '15px',
  position: 'relative',
  marginBottom: '20px'
};

const dottedUnderline = {
  borderBottom: '1px dashed #000',
  padding: '0 5px',
  fontWeight: 'bold',
  display: 'inline',
  textAlign: 'center',
  whiteSpace: 'nowrap'
};

const overlayStyle = {
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  background: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 3000
};

const modalStyle = {
  background: '#fff',
  padding: '20px',
  borderRadius: '8px',
  width: '500px',
  maxWidth: '90%'
};

const tableHeaderStyle = { padding: '10px', textAlign: 'left', borderBottom: '1px solid #ddd' };
const tableCellStyle = { padding: '10px', borderBottom: '1px solid #eee' };

export default Form15A;
